import { useMemo } from 'react';
import { Link, useTranslation } from '@weareconceptstudio/core';

//* Styles
import ButtonStyle from './style';

const Button = ({ btnType, text, className, onClick, url, type = 'button', disabled = false, children, external = false, ariaLabel = url }) => {
	const { translate } = useTranslation();

	//! Checks
	const Component = useMemo(() => (url ? Link : 'button'), [url]);
	const customProps = useMemo(() => (url ? { url, ariaLabel, external } : { type, disabled }), [url, external, type, disabled, ariaLabel]);

	let btn;

	switch (btnType) {
		case 'double':
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${btnType || ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
				>
					<Component {...customProps}>
						<div className='content-wrap'>
							<div className='real-text'>{children || translate(text)}</div>
							<div className='fake-text'>{children || translate(text)}</div>
						</div>
					</Component>
				</ButtonStyle>
			);
			break;

		default:
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${btnType || ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
				>
					<Component {...customProps}>{children || translate(text)}</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default Button;
